import axios from "../axios";
import { Cookies } from 'react-cookie'
const endPoint = `/rate`

const cookie = new Cookies()

const token = await cookie.get('user')

export const createRate = async (product_id, rate, address_rate, text_rate) => {
    return axios.post(`${endPoint}/create/${product_id}`, {
        rate: rate,
        address_rate: address_rate,
        text_rate: text_rate
    }
        , { headers: { authorization: token } })
}

export const updateRate = async (product_id, rate, address_rate, text_rate) => {
    return axios.put(`${endPoint}/update/${product_id}`, {
        rate: rate,
        address_rate: address_rate,
        text_rate: text_rate
    }
        , { headers: { authorization: token } })
}

export const DeleteRate = async (product_id) => {
    return axios.delete(`${endPoint}/delete/${product_id}`,
     { headers: { authorization: token } })
}

export const hasRate = async (product_id) => {
    return axios.get(`${endPoint}/hasRated/${product_id}`,
     { headers: { authorization: token } })
}